export const leftVariant = {
    visible: { rotate: 0, x: 0, opacity: 1, transition: { duration: 0.5 } },
    hidden: { x: 100, rotate: 0, opacity: 0 },
}

export const rightVariant = {
    visible: { rotate: 0, x: 0, opacity: 1, transition: { duration: 0.5 } },
    hidden: { x: -100, rotate: 0, opacity: 0 },
}

export const animationVariants = {
    initial: { x: '-100px' },
    animate: { x: '0px', transition: { duration: 1, ease: 'easeOut' } },
}
export const animationVariantsRight = {
    initial: { x: '100px' },
    animate: { x: '0px', transition: { duration: 1, ease: 'easeOut' } },
}

export const animationVariantsSuccess = {
    hidden: { opacity: 0, x: '-100px' },
    visible: {
        opacity: 1,
        x: '0px',
        transition: { duration: 0.5, ease: 'easeOut' },
    },
}

export const animationVariantsRightSuccess = {
    hidden: { opacity: 0, x: '100px' },
    visible: {
        opacity: 1,
        x: '0px',
        transition: { duration: 0.5, ease: 'easeOut' },
    },
}
export const scaleVariantSuccess = {
    visible: {
        scale: 1,
        rotate: 0,
        x: 0,
        y: 0,
        opacity: 1,
        transition: { duration: 0.5 },
    },
    hidden: { scale: 0, x: 0, y: 0, rotate: 0, opacity: 0.6 },
}

export const scaleVariant = {
    animate: {
        scale: 1,
        rotate: 0,
        x: 0,
        y: 0,
        opacity: 1,
        transition: { duration: 1 },
    },
    initial: { scale: 0, x: 0, y: 0, rotate: 0, opacity: 0.6 },
}
export const scaleVariantTitle = {
    visible: {
        scale: 1,
        rotate: 0,
        x: 0,
        y: 0,
        opacity: 1,
        transition: { duration: 0.5 },
    },
    hidden: { scale: 0, x: 0, y: 0, rotate: 0, opacity: 0.6 },
}

export const bottomVariant = {
    visible: {
        rotate: 0,
        y: 0,
        opacity: 1,
        transition: { duration: 0.5 },
    },
    hidden: {
        rotate: 0,
        y: 300,
        opacity: 0,
    },
}
export const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            delayChildren: 0.3,
            staggerChildren: 0.2,
        },
    },
}

export const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
    },
}
